module.exports = global["ReactBootstrap"] = require("-!./index.js");